/* 404 / unknown-route view.
 *
 * Wired in two ways:
 *   1. Registered as the /notfound route in app.js so it can be hit
 *      directly via #/notfound (or linked to from anywhere).
 *   2. router.js falls back to this handler when no registered route
 *      matches the current hash. The router does NOT change the URL —
 *      we want the user to see the bad path they typed (helps them
 *      catch a typo) and we want Back to return them to whatever was
 *      previously rendered, not loop them through the 404.
 *
 * Visual reuses the .empty-state pattern (medallion icon + title +
 * body + actions row) so this surface feels native to the rest of the
 * app rather than a one-off dead-end. The "info" variant gives it the
 * sky-blue medallion — informational, not alarming. A small muted
 * "Tried: …" line under the actions surfaces what the router actually
 * tried to resolve, which is gold for self-debugging a stale link.
 */

import { currentPath } from "../router.js";

export function renderNotFound(view, params) {
  // The router records the failed path in _current before invoking us,
  // so currentPath() returns whatever the user typed (sans hash). The
  // fallback parameter is in case we're invoked from a context where
  // currentPath isn't populated yet.
  const tried = (currentPath() || (params && params.get("from")) || "").trim();

  view.innerHTML = `
    <section class="notfound">
      <div class="empty-state empty-state-info">
        <div class="empty-state-icon" aria-hidden="true">🩺</div>
        <h2 class="empty-state-title">Empty chart</h2>
        <p class="empty-state-body">
          We couldn't find that page. The link might be stale, or off by a
          character. Pick where to go from here:
        </p>
        <div class="empty-state-actions">
          <a class="btn btn-primary" href="#/home">Home</a>
          <a class="btn btn-ghost" href="#/practice">Practice</a>
        </div>
      </div>
      ${tried ? `
        <p class="notfound-tried muted small">
          Tried: <code>${esc("#" + tried)}</code>
        </p>
      ` : ""}
    </section>
  `;
}

function esc(s) {
  return String(s ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}
